'use client';
import { useMemo } from 'react';
import { useCarouselState } from '@hooks/useCarouselState';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  darkMode?: boolean;
}

const AnimatedSlider = ({ darkMode }: Props) => {
  const state = useCarouselState();

  const width = useMemo(
    () => (state.visibleSlides / state.totalSlides) * 100,
    [state.visibleSlides, state.totalSlides],
  );
  const left = useMemo(() => {
    const steps = state.totalSlides - state.visibleSlides;
    const stepWidth = (100 - width) / steps;
    const containerPercent = state.currentSlide * stepWidth;
    const multiplier = 100 / width;
    return containerPercent * multiplier;
  }, [state.totalSlides, state.visibleSlides, state.currentSlide, width]);

  return (
    <div>
      <div
        className={classNames(
          'tw-h-1 tw-mb-0.5 tw-w-full tw-translate-y-2',
          darkMode ? 'tw-bg-transparent-dark-200' : 'tw-bg-transparent-light-200',
        )}
      ></div>
      <div
        className={classNames(
          ' tw-h-2 tw-relative tw-transition-transform tw-duration-500 tw-ease-in tw-left-0',
          darkMode ? 'tw-bg-neutral-100' : 'tw-bg-neutral-700',
        )}
        style={{ width: `${width}%`, transform: `translateX(${left}%)` }}
      />
    </div>
  );
};

export default AnimatedSlider;
